<template>
  <AppWithLoading :fetch="fetchHandler" v-slot:default="{localLoading, loader}">
    <div v-if="!requireFailedRenewal || hasFailedRenewal">
      <template v-if="!localLoading">
        <slot
          v-bind="{
            prolongSubscriptionPayment,
            loader,
            hasActivePaymentMethod,
            error,
            hasFailedRenewal,
            errorStripe
          }"
        />
      </template>
    </div>
  </AppWithLoading>
</template>

<script>
import useSubscription from '@/compositions/accounting/useSubscription';
import useStripe from '@/compositions/accounting/useStripe';
import useAlfabank from '@/compositions/accounting/useAlfabank';
import useAccount from '@/compositions/accounting/useAccount';
import { ref } from '@vue/composition-api';
import { orderPlanOperations, orderTypes, paymentDrivers } from '@/enums';
import AppWithLoading from '@/components/AppWithLoading';

export default {
  name: 'ProlongSubscriptionResolver',
  components: { AppWithLoading },
  props: {
    requireFailedRenewal: {
      type: Boolean,
      default: true,
    },
    fetchOnMount: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit, root: { $router } }) {
    const error = ref(null);
    const { hasFailedRenewal } = useSubscription();
    const { account, fetchIfNull, fetch } = useAccount();
    const { prolongSubscriptionPayment: prolongSubscriptionAlfabankPayment } = useAlfabank();

    function onSuccessProlongation() {
      $router.replace({
        name: 'order-success',
        params: {
          id: account.value.plan.id,
          operation: orderPlanOperations.PROLONG,
          type: orderTypes.PLAN,
        },
      });
    }

    async function resolveProlongationResult() {
      await fetch();

      if (account.value?.hasFailedRenewal) {
        $router.replace({ name: 'order-failed' });
        return;
      }

      onSuccessProlongation();
    }

    const {
      prolongSubscriptionPayment: prolongSubscriptionStripePayment,
      error: errorStripe,
    } = useStripe({
      onSuccess: async () => {
        await resolveProlongationResult();
      },
      onFailure: (e) => {
        emit('error', e);
        error.value = e.message;
      },
    });

    async function prolongSubscriptionPayment() {
      if (account.value?.driver === paymentDrivers.ALFABANK) {
        try {
          const result = await prolongSubscriptionAlfabankPayment();
          
          if (result?.redirect) {
            window.location.href = result.redirect;
            return;
          }

          await resolveProlongationResult();
        } catch (e) {
          emit('error', e);
          error.value = e.message;
        }
        return;
      }

      await prolongSubscriptionStripePayment();
    }
    const { hasActivePaymentMethod } = useAccount();
    const fetchHandler = props.fetchOnMount ? fetchIfNull : null;

    return {
      error,
      errorStripe,
      hasFailedRenewal,
      prolongSubscriptionPayment,
      hasActivePaymentMethod,
      fetchHandler,
    };
  },
};
</script>
